/**
 * Get url to LK
 * @param {String} url - api url without api/{service}/
 */
export const getUrlToLKApi = url => `api/lk/${url}`;
export const getUrlToApi = url => `api/${url}`;
